import { GAME_STATES }   from '../../constants/gameStates/game-states.constant'
import { disabled }      from '../../classes/button/button.class.scss'
import { SPIN_STATE }    from '../../constants/spinState/spin-state.constant'

/**
 * @file Defines the {@link ButtonStatesManager} class
 * @author Joe Thompson <joe.thompson@1x2network.com>
 */

/** Class for handling states of buttons depending on game state */
export class ButtonStatesManager {

    /**
     * Stores current button we are handling
     * @memberof ButtonStatesManager
     * @protected
     * @instance
     * @type {string}
     */
    _button
    
    /**
     * Stores current buttons we are dealing with
     * @memberof ButtonStatesManager
     * @protected
     * @instance
     * @type {string[]}
     */
    _buttons

    constructor() {}

    /**
     * Applies game state to handle button states
     * @param {string} s_ - Current state 
     */
    applyState(s_) {
        console.log(s_) //USED FOR DEBUGGED PURPOSES TO JUDGE CURRENT STATE
        let enable    = GAME_STATES.states[s_] //Retrieve whether button is enabled/disabled
        this._buttons = Object.keys(enable)    //Store buttons
        let enabled   = Object.values(enable)  //Store whether button is enabled/disabled

        //Possible move this elsewhere - to another class that handles specific behaviours for specific state
        //If initial state
        if (s_ === 'NH') {
            SPIN_STATE.spinning = false //Game finished spinning
        }

        //If game is spinning
        else if (s_ === 'SPIN' || s_ === 'APSPIN') {
            SPIN_STATE.spinning = true //Set spin state
        }

        SPIN_STATE.onSpin.dispatch(SPIN_STATE.spinning) //Dispatch onSpin event

        //Lopp through all buttons
        for (let i = 0; i < this._buttons.length; i++) {
            
            this._button = this._buttons[i]      //Store current button
            let e        = enabled[i].toString() //Retrieve whether current button is enabled

            e === 'enable' ? window.newUI[this._button]().enable = true : window.newUI[this._button]().enable = false //Enable/disable button

            //Switch on button
            switch (this._button) {

                //Spin button
                case 'spin':
                    window.newUI[this._button]().state = GAME_STATES.spin[s_] //Apply state to spin button
                    break
                
                //Autospin button    
                case 'autospin':
                    window.newUI[this._button]().state = GAME_STATES.autospin[s_] //Apply state to autospin button
                    break

            }

        }

    }

}